export default {
  "data-extraction": "Data Extraction",
  "repartition-identities": "Repartition Identities",
  "Patient Matching": "Matcher"
};
